/* eslint-disable */
import React from "react";
import { Card, Text, Grid, Box, Group, Stack } from "@mantine/core";

interface TimelineChartProps {
  totalWorkingHours?: string;
  productiveHours?: string;
  breakHours?: string;
  overtimeHours?: string;
}
const barHeights = [100, 60, 90, 50, 80, 40, 70, 65, 55, 45, 75, 50];
const barColors = [
  "#22c55e",
  "#fbbf24",
  "#22c55e",
  "#fbbf24",
  "#22c55e",
  "#fbbf24",
  "#3b82f6",
  "#3b82f6",
  "#22c55e",
  "#fbbf24",
  "#22c55e",
  "#3b82f6",
];
const TimelineChart: React.FC<TimelineChartProps> = ({
  totalWorkingHours,
  productiveHours,
  breakHours,
  overtimeHours,
}) => {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Stack spacing="lg">
        <Grid gutter="xs">
          <Grid.Col xs={6} sm={3}>
            <Stack spacing={2}>
              <Text size="xs" color="dimmed">
                Total Working Hours
              </Text>
              <Text fw={700}>{totalWorkingHours}</Text>
            </Stack>
          </Grid.Col>
          <Grid.Col xs={6} sm={3}>
            <Stack spacing={2}>
              <Text size="xs" color="dimmed">
                Productive Hours
              </Text>
              <Text fw={700}>{productiveHours}</Text>
            </Stack>
          </Grid.Col>
          <Grid.Col xs={6} sm={3}>
            <Stack spacing={2}>
              <Text size="xs" color="dimmed">
                Break Hours
              </Text>
              <Text fw={700}>{breakHours}</Text>
            </Stack>
          </Grid.Col>
          <Grid.Col xs={6} sm={3}>
            <Stack spacing={2}>
              <Text size="xs" color="dimmed">
                Overtime
              </Text>
              <Text fw={700}>{overtimeHours}</Text>
            </Stack>
          </Grid.Col>
        </Grid>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            height: 120, // slightly taller for better visual balance
            gap: 6,
            width: "100%",
          }}
        >
          {barHeights.map((h, idx) => (
            <Box
              key={idx}
              sx={{
                flex: 1, // this makes all bars share available space equally
                height: `${h}%`,
                backgroundColor: barColors[idx],
                borderRadius: 3,
                transition: "height 0.3s ease",
              }}
            />
          ))}
        </Box>

        <Group position="apart" spacing="xs" noWrap>
          {[
            "09:00 AM",
            "10:00 AM",
            "11:00 AM",
            "12:00 PM",
            "01:00 PM",
            "02:00 PM",
            "03:00 PM",
            "04:00 PM",
            "05:00 PM",
            "06:00 PM",
          ].map((t, i) => (
            <Text key={i} size="xs" color="dimmed" sx={{ flexShrink: 0 }}>
              {t}
            </Text>
          ))}
        </Group>
      </Stack>
    </Card>
  );
};
export default TimelineChart;
